<div class="page-content">
    <app-page-title [pageTitle]="pagetitle" [pageSubtitle]="'marketplace_subtitle' | translate"></app-page-title>
    <div class="row-fluid" *ngIf="showTestButtons">
        <button (click)="getReport()">Report</button>
        <button (click)="getCart()">Cart</button>
        <button (click)="downloadReport()">Download</button>
        <button (click)="addNewOrder()">New Order</button>
        <button (click)="checkout()">Checkout</button>
        <button (click)="chartData()">Chart</button>
        <button (click)="envelope()">Envelope</button>
    </div>
    <div class="row-fluid">
        <ngx-delfi-products-list [groupby]="'innovation'" [template]="'card'" [serviceendpoint]="serviceEndpoint" [submissionsidebar]="false" [hideActions]="true" (onProductClick)="onProductClicked($event)"></ngx-delfi-products-list>
    </div>
</div>
